var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "persistent": _vm.persistent || !!_vm.cancelCheck,
      "highest-order": _vm.highestOrder,
      "order": _vm.order
    },
    on: {
      "closed": _vm.handleCanceled
    },
    model: {
      value: _vm.isActive,
      callback: function ($$v) {
        _vm.isActive = $$v;
      },
      expression: "isActive"
    }
  }, [_c('card', {
    attrs: {
      "width": _vm.modalWidth,
      "height": _vm.modalHeight,
      "max-width": "100%",
      "max-height": _vm.maxModalHeight,
      "no-spacing": "",
      "loading": _vm.isLoading,
      "tile": _vm.isFullscreen,
      "xs-tile": ""
    },
    on: {
      "update:loading": function ($event) {
        _vm.isLoading = $event;
      }
    }
  }, [_vm.title || _vm.$slots.title ? _c('div', {
    staticClass: "flex justify-between py-16 px-16 md:py-20 lg:px-24 border-b"
  }, [_c('div', {
    staticClass: "flex flex-column truncate"
  }, [_vm._t("title"), _vm._v(" "), _vm.title ? _c('p', {
    staticClass: "text-md font-bold text-heading-color truncate mb-0"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm.subtitle ? _c('p', {
    staticClass: "text-xs text-subtext-color leading-normal mb-0 mt-2 whitespace-normal"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()], 2), _vm._v(" "), _vm.closeable ? _c('div', [_c('icon', {
    staticClass: "text-gray-400 hover:text-gray-500 cursor-pointer",
    attrs: {
      "icon": _vm.$icons.close
    },
    on: {
      "click": _vm.cancel
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("header"), _vm._v(" "), _c('card-text', {
    staticClass: "border-box overflow-y-auto",
    class: [_vm.contentClass, {
      'p-0': _vm.noPadding
    }],
    attrs: {
      "fill": ""
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("footer"), _vm._v(" "), _vm.showCloseButton && _vm.closeable || _vm.$slots.button ? _c('wrapper', {
    staticClass: "px-16 py-16 lg:px-24 border-box border-t",
    attrs: {
      "grow": !!_vm.$slots.button,
      "between": "",
      "break-column": _vm.buttonBreakColumn
    }
  }, [_vm.showCloseButton && _vm.closeable ? _c('btn', {
    staticClass: "max-w-120",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$trans('action.close', 'Schließen')))]) : _vm._e(), _vm._v(" "), _vm._t("button")], 2) : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }